export default __webpack_public_path__ + "static/bg-data-hexagons-8f47eae25baf977ee8e769721d85769f.png";